import React from 'react'
import { GraphMenuScreenOverlay, GraphMenuContainerDiv } from './styled-elements'

const GraphMenuContainer  = ({ available, visible, clickHandler, overlayClickHandler, children }) => {

  if (!available) return null
  if (!visible) return null

  const ret = <GraphMenuScreenOverlay onClick={e => overlayClickHandler(e)}>
    <div style={{ position: 'absolute', zIndex: 30, top: '38px', left: '10px' }}>
      <GraphMenuContainerDiv>
        {children}
      </GraphMenuContainerDiv>
    </div>
  </GraphMenuScreenOverlay>

  return ret

}

export default GraphMenuContainer



// WEBPACK FOOTER //
// ./src/components/dataViews/controls/GraphMenuContainer.js